import { Vue, Component } from 'vue-property-decorator'
import LinkItem from '~/types/LinkItem'
import Breadcrumb from '~/components/page/Breadcrumb'
import loc from '~/utils/loc'
import DeliveryPayment from '~/components/page/help/DeliveryPayment'
import s from '~/utils/s'
import mainBreadcrumbsSubmenuItems from '~/utils/mainBreadcrumbsSubmenuItems'

@Component
export default class extends Vue {
  title: string = 'Доставка и оплата'

  breadcrumb: LinkItem[] = [
    {
      title: 'Главная',
      location: loc(this.$store, { name: 'index' }),
      submenuItems: mainBreadcrumbsSubmenuItems(this.$store)
    },
    {
      title: 'Доставка и оплата',
      location: loc(this.$store, {
        name: 'help-delivery-payment'
      })
    }
  ]

  async mounted () {
    const regionId = s(this.$store).regions.regionId
    const sectionId = s(this.$store).regions.sectionId
    await s(this.$store).staticPages.getStaticPage({ code: 'delivery-payment', regionId, sectionId })
    const staticPage = s(this.$store).staticPages.staticPage
    s(this.$store).seo.setTitle(staticPage.SEOTitle)
    s(this.$store).seo.setDescription(staticPage.SEODescription)
    s(this.$store).seo.setKeywords(staticPage.SEOKeywords)
  }

  render () {
    return (
      <div class="common-page">
        <div class="common-page__header">
          <div class="page-header">
            <div class="page-header__container">
              <div class="page-header__breadcrumb">
                <Breadcrumb {...{
                  props: {
                    items: this.breadcrumb
                  }
                }} />
              </div>
              <h1 class="common-page__h1">
                {s(this.$store).staticPages.staticPage.title}
              </h1>
            </div>
          </div>
        </div>
        <div class="common-page__content">
          <div class="common-page__content-row">
            <div class="common-page__content-col">
              <DeliveryPayment />
            </div>
          </div>
        </div>
      </div>
    )
  }
}
